// Reduce las peticiones generadas mientras el usuario todavía está escribiendo.
// Unipei usa EasyAutocomplete (no jquery-ui), por eso se aplican sus opciones
// nativas antes de que las vistas inicialicen cada campo.
import $ from "jquery"
require("easy-autocomplete")

const originalEasyAutocomplete = $.fn.easyAutocomplete

if (typeof originalEasyAutocomplete === "function") {
  $.fn.easyAutocomplete = function (options) {
    const throttledOptions = Object.assign({}, options)

    if (throttledOptions.requestDelay == null) throttledOptions.requestDelay = 500
    if (throttledOptions.minCharNumber == null) throttledOptions.minCharNumber = 2

    return originalEasyAutocomplete.call(this, throttledOptions)
  }
}

// Los listados remotos enlazan sus búsquedas mediante .keyup() sobre el mismo
// id. Se retrasa solamente ese patrón y se dejan intactos los demás keyups.
const originalKeyup = $.fn.keyup
const SEARCH_WAIT_MS = 400

$.fn.keyup = function (handler) {
  if (typeof handler === "function" && this.is("#searchInput")) {
    let timer = null

    return originalKeyup.call(this, function () {
      const context = this
      const args = arguments
      clearTimeout(timer)
      timer = setTimeout(() => handler.apply(context, args), SEARCH_WAIT_MS)
    })
  }

  return originalKeyup.apply(this, arguments)
}
